/**
 * Farlo UI | List Input
 *
 * @autho Farlo
 */

class FarloUiList {
	constructor(element) {
		this.element = element;
		this.initialiseButtonTextReplacer(this.element);
	}

	initialiseButtonTextReplacer(buttonContainer) {
		const addButton = buttonContainer.querySelector('button.add_list_item');
		const removeButton = buttonContainer.querySelector('button.delete_list_item');

		if (addButton && removeButton) {
			addButton.innerHTML = '+';
			removeButton.innerHTML = '-';
		}
	}
}
export default FarloUiList;
